import en from './en/index';
import tw from './tw/index';
import cn from './cn/index';
import bo from './bo/index';

export default {
  en,
  tw,
  cn,
  bo,
};



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js